// extracted by mini-css-extract-plugin
export var orderDetails = "_of-2";
export var orderImage = "_of-1";
export var orderMeta = "_of-3";
export var orderSummary = "_of-0";
export var rightArrow = "_of-4";